import { trackException } from 'app-insights/appInsightsTracking';
import { ExceptionType } from 'app/enums/Common';
import { PlacementService } from 'app/services/PlacementServices/placement-service';
import { httpSuccess } from 'app/services/serviceHelpers';
import { call, getContext, put } from 'redux-saga/effects';
import { placementSummaryActions } from '../slice';
import InitPlacementSummary, { IConsolidatedRequirementResponse } from '../init.types';
import { resetFailureStatus } from '../saga';
import { extractOpts } from '../helper';

export function* requestTravelTimePicklist() {
  try {
    yield put(resetFailureStatus('travelTimePreferenceOpts'));

    const placementService: PlacementService = yield getContext('placementService');

    const response = yield call(placementService.getTravelTimePreferencePicklist);
    if (httpSuccess(response?.status))
      yield put(
        placementSummaryActions.setOfferTransportationPickListByKey({
          key: 'travelTimePreferenceOpts',
          data: response.data,
        }),
      );
  } catch (error) {
    trackException({
      exception: error,
      properties: {
        name: ExceptionType.APIRequestError,
        functionName: 'requestTravelTimePicklist',
        area: 'src/store/redux-store/placement-summary/common-saga/requestTravelTimePicklist.ts',
      },
    });
  }
}

export function processTravelTimePicklist(
  response: IConsolidatedRequirementResponse<any>,
  context: InitPlacementSummary,
) {
  try {
    if (!httpSuccess(response?.status)) {
      context.setServiceFailureByKey({ key: 'travelTimePreferenceOpts', failureStatus: true });
      return;
    }
    const extractedData = extractOpts('travelTimePreferenceOpts', response.data);

    context.setOfferTransportationPickListByKey({ key: 'travelTimePreferenceOpts', data: extractedData });
  } catch (error) {
    trackException({
      exception: error,
      properties: {
        name: ExceptionType.CommonSAGAError,
        functionName: 'processTravelTimePicklist',
        area: 'src/store/redux-store/placement-summary/common-saga/requestTravelTimePicklist.ts',
      },
    });
  }
}
